import script from "./HexColorField.vue?vue&type=script&setup=true&lang=js"
export * from "./HexColorField.vue?vue&type=script&setup=true&lang=js"

import "./HexColorField.vue?vue&type=style&index=0&id=0f4d1f3b&scoped=true&lang=css"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0f4d1f3b"]])

export default __exports__